<template lang="pug">
	span(v-on-click-outside="close")
		span.icon-info(:id="tooltipID" @click="clicked ? close($event) : clickAnimation()" :class="{clicked: clicked}")
			<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" alt="">
				<g fill="none" fill-rule="evenodd"> <g :fill="fillColor"> <g> <g> <g> <g> <path d="M7.995 6.08c-.646 0-1.169-.522-1.169-1.17 0-.645.523-1.169 1.169-1.169s1.169.524 1.169 1.17v.002c0 .645-.523 1.168-1.168 1.168h-.001zm-1.067 6.17h2.134V6.97H6.928v5.28zm6.721-9.906c-3.122-3.125-8.185-3.125-11.307 0-3.123 3.123-3.123 8.189 0 11.313 3.122 3.124 8.185 3.124 11.307 0 3.123-3.108 3.136-8.16.03-11.284l-.03-.03z" transform="translate(-440 -1540) translate(0 1034) translate(132 369) translate(208 134) translate(100 3)"/> </g> </g> </g> </g> </g> </g>
			</svg>
		b-tooltip(:target="tooltipID"  :show.sync="clicked" triggers="none" ref="tooltip")
			span(v-html="tooltipTitle()")
			div(style='text-align:center;margin-top:5px')
				slot
				span.tooltip-close(@click="close($event)")
					| Close
</template>

<style lang="stylus" scoped>
@import '~assets/css/redesign-v1/variables.styl'

.icon-info
	position: relative
	display: inline-block
	cursor: pointer
.tooltip-close
	font-size: body-font-size-sm
	text-decoration: underline
	cursor: pointer
</style>

<script>
import Vue from 'vue'

import {directive as onClickOutside} from 'vue-on-click-outside'

Vue.directive('on-click-outside', onClickOutside)

export default {

	props: {
		'title': {
			default: undefined
		},
		'startOpened': {
			default: false
		},
		'fillColor': {
			default: "#1E6BD6"
		}
	},

	data(){
		return {
			clicked: false,
			tooltipID: Math.floor(Math.random() * 1123).toString()
		}
	},

	mounted(){
		if(this.startOpened) {
			this.clickAnimation()
		}
	},
	computed: {

	},
	methods: {
		tooltipTitle(){
			return this.title
		},
		close(event){
			if(event){
				event.stopPropagation()
			}
			this.$root.$emit('bv::hide::tooltip', this.tooltipID);
			this.clicked = false
		},
		clickAnimation(){
			this.$root.$emit('bv::hide::tooltip');
			this.$root.$emit('bv::show::tooltip', this.tooltipID);
			this.clicked = true
		}
	}
}
</script>
